import { Text } from '../../../components/Text';
import { Doughnut, Pie } from 'react-chartjs-2';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';
import styles from '../style.module.scss';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getDate } from '../../../utils/datemaker';
import { useSelector } from 'react-redux';
import { Skeleton } from 'primereact/skeleton';
import EllipsisText from '../../../components/common/EllipsisText/indix';
import { ReactComponent as Edit } from '../../../svg/edit.svg';
import { ReactComponent as DocIcon } from '../../../assets/docPreview.svg';
import { ReactComponent as CampaignIcon } from '../../../assets/campaign.svg';
import { ReactComponent as ConversationIcon } from '../../../assets/conversation.svg';
import { ReactComponent as VideoPreview } from '../../../assets/videoPreview.svg';
import { ReactComponent as DashboardCampaign } from '../../../assets/svgIcons/dashboard_campaign.svg';
import { ReactComponent as DashboardConversations } from '../../../assets/svgIcons/dashboard_conversation.svg';

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { ReactComponent as ClockIcon } from '../../../assets/svgIcons/clock.svg';
import { ReactComponent as ClockHoldIcon } from '../../../assets/svgIcons/clockhold.svg';
import { Image } from 'primereact/image';
import { useLayout } from '../../../context/LayoutContext';
import { refineMessage } from '../../../utils/templateUtils';
import CampScheduleTime from '../../../components/CampScheduleTime';
import CampaignRowAnalytics from '../../WCA/WCACampaign/CampaignRowAnalytics';
import CustomSkeleton from '../../../components/CustomSkeleton';
import ImageGallary from '../../../components/common/ImageGallary';
import { useUtility } from '../../../context/UtilityContext';
ChartJS.register(ArcElement, Tooltip, Legend);

function CampaignsSectionsWCA() {
  const { userSub, loading } = useSelector((state) => state.authenticate);
  const [campaignDataWithSR, setCampaignDataWithSR] = useState([]);
  const [clickedCampaign, setClickedCampaign] = useState();
  const { selectedMetadataId } = useUtility();
  const { campaignData, campaignLoading, campaignCount } = useSelector((state) => state.wcaCampaign);
  const navigate = useNavigate();
  const [displayCampaigns, setDisplayCampaigns] = useState([]); // For table display (limited to 10)

  const [campaignDetail, setCampaignDetail] = useState({
    totalcampaign: 0,
    totalschedule: 0,
    success: 0,
    onhold: 0,
  });
  const [coversationDetail, setCoversationDetail] = useState({
    usedConversation: 0,
    successRate: 0,
  });



  useEffect(() => {

    if (campaignLoading) {
      setCampaignDetail({ totalcampaign: 0, totalschedule: 0, success: 0, onhold: 0 });
      setCoversationDetail({ usedConversation: 0, successRate: 0 });
      return;
    }

    if (!campaignData || campaignData.length === 0) {
      setCampaignDetail({ totalcampaign: 0, totalschedule: 0, success: 0, onhold: 0 });
      setCoversationDetail({ usedConversation: 0, successRate: 0 });
      return;
    }

    let totalMessages = 0, totalSent = 0, totalDelivered = 0,
      totalRead = 0, totalFailed = 0;

    campaignData.forEach((campaign) => {
      const { total, sent, delivered, read, failed } = campaign.analytics || {};
      totalMessages += total || 0;
      totalSent += sent || 0;
      totalDelivered += delivered || 0;
      totalRead += read || 0;
      totalFailed += failed || 0;
    });


    const success = totalDelivered + totalRead;
    const schedule = 0;
    const hold = 0;
    const successRate = totalMessages > 0
      ? parseFloat(((success / totalMessages) * 100).toFixed(1))
      : 0;


    setCampaignDetail({
      totalcampaign: campaignCount || 0,
      totalschedule: schedule,
      success: success,
      onhold: hold,
    });
    setCoversationDetail({
      usedConversation: totalMessages,
      successRate: successRate,
    });
  }, [campaignData, campaignCount, campaignLoading]);

  const getHeaderMedia = (rowData) => {
    const header = rowData?.variables?.HEADER;

    if (!header) return null;
    if (header.IMAGE) return { type: 'image', data: header.IMAGE };
    if (header.VIDEO) return { type: 'video', data: header.VIDEO };
    if (header.DOCUMENT) return { type: 'document', data: header.DOCUMENT };

    return null;
  };

  const getMediaLink = (mediaData) => {
    if (!mediaData) return '';
    if (mediaData.link) return mediaData.link;

    const values = mediaData.values;
    if (values && typeof values === 'object') {
      const firstKey = Object.keys(values)[0];
      return firstKey ? values[firstKey] : '';
    }

    return '';
  };

  const mediaBody = (rowData) => {
    const continerStyle = {
      width: 'auto',
      maxHeight: '50px',
      aspectRatio: '16/9',
    };

    const { campaignType, templateType, variables } = rowData;

    if (campaignType === 'product') {
      const { productItems } = rowData;
      let prodImages = [];
      productItems?.forEach((prod) => {
        const images = prod?.images;
        if (images) {
          prodImages = [...prodImages, ...images];
        }
      });
      return (
        <div
          className="flex justify-content-start align-items-center gap-2"
          style={continerStyle}
          onClick={(e) => e.stopPropagation()}
        >
          {prodImages.length > 0 ? <ImageGallary images={prodImages} /> : ''}
        </div>
      );
    }

    const headerMedia = getHeaderMedia(rowData);
    const normalizedTemplateType = headerMedia?.type || templateType?.toLowerCase();
    const mediaUrl = getMediaLink(headerMedia?.data) || variables?.mediaUrl;

    switch (normalizedTemplateType) {
      case 'video':
        return (
          <div className="flex flex-row align-items-center align-content-center  justify-content-between ">
            <div
              className={`flex flex-row align-items-center align-content-center  justify-content-center surface-100 cthumbnailContainer`}
            >
              <div className="flex flex-row justify-content-center align-items-center align-content-center surface-0">
                <div
                  style={{
                    objectFit: 'cover',
                    width: '60px',
                    height: '100%',
                    background: '#000',
                    top: 0,
                    left: 20,
                    position: 'absolute',
                  }}
                >
                  <VideoPreview
                    width="auto w-12"
                    height="30"
                    className="absolute"
                    style={{ top: 10, left: 0 }}
                  />
                </div>
              </div>
              <Text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
            </div>
          </div>
        );
      case 'image':
        return (
          <div
            className="flex justify-content-start z-5 "
            style={continerStyle}
            onClick={(e) => e.stopPropagation()}
          >
            <ImageGallary images={mediaUrl ? [{ url: mediaUrl }] : variables} />
            <Text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
          </div>
        );
      case 'document':
        return (
          <div className="flex justify-content-start " style={continerStyle}>
            <div className="flex justify-content-center pt-2 w-6 ">
              <a
                href={mediaUrl}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                target="_blank"
                rel="noreferrer"
              >
                <DocIcon width="35" height="35" />
              </a>
            </div>
            <Text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
          </div>
        );
      default:
        return (
          <div className="flex justify-content-start align-items-end gap-2" style={continerStyle}>
            <div className="flex justify-content-center w-6 pb-2">
              <Text>_</Text>
            </div>
            <Text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
          </div>
        );
    }
  };



  useEffect(() => {
    if (!selectedMetadataId || campaignData.length === 0) {
      setCampaignDataWithSR([]);
      setDisplayCampaigns([]);
      return;
    }


    const campaignsForDisplay = campaignData.slice(0, 10);
    setDisplayCampaigns(campaignsForDisplay);

    const updatedCampaignData = campaignsForDisplay.map((campaign) => {
      const { total, sent, delivered, read, failed } = campaign.analytics || {};

      const success = (delivered || 0) + (read || 0);
      const successRate =
        (total || 0) > 0
          ? parseFloat(((success / total) * 100).toFixed(1))
          : 0;

      return {
        ...campaign,
        successRate,
        totalStatus: total || 0,
        sent: sent || 0,
        delivered: delivered || 0,
        read: read || 0,
        failed: failed || 0,
        failedStatus: failed || 0,
        conversationsCount: total || 0,
        showgrapg: success || sent || failed,
      };
    });

    setCampaignDataWithSR(updatedCampaignData);
  }, [campaignData, selectedMetadataId]);

  const handleCampaignSelect = (campaign) => {
    if (campaign.Type === 'ScheduledCampaign') {
      navigate(`/campaigns/s-${campaign.id}`);
    } else navigate(`/campaigns/${campaign.id}`);
  };

  const successRateBodyTemplate = (data) => {
    return (
      <div className="flex gap-2 justify-content-between align-items-center w-12 ">
        {data.Type === 'ScheduledCampaign' && (
          <div>
            {!(data.hold === '1' || data.hold === true) ? <ClockIcon /> : <ClockHoldIcon />}
          </div>
        )}
        {data.Type === 'ScheduledCampaign' && (
          <CampScheduleTime isHold={data?.hold} nextRun={data?.nextRun} />
        )}

        {data.Type !== 'ScheduledCampaign' && <CampaignRowAnalytics campaignDetails={data} />}
      </div>
    );
  };
  return (
    <div className="w-full">
      <div
        className={`w-full ${styles['record-wrap-stat']} p-2 flex flex-column md:flex-row gap-3`}
      >
        <div className="w-full md:w-6 flex flex-column  bg-white">
          <div className="p-2 flex flex flex-row align-items-center gap-2">
            <div className="m-2">
              <DashboardCampaign />
            </div>
            <div className=" font-bold flex flex-row gap-2  ">
              <div className="font-normal">Total Campaigns</div>
              {campaignLoading ? (
                <div>
                  <CustomSkeleton
                    parentcss={'flex'}
                    countline={1}
                    height={'1.5rem'}
                    width={'2rem'}
                    className="border-round "
                  />
                </div>
              ) : (
                <div className="">{campaignDetail.totalcampaign}</div>
              )}
            </div>
          </div>
          <div className="pl-8 ">
            <div className="flex flex-row pb-2 pr-2 gap-4 lg:gap-0 ">
              <div className={`flex-1 p-1`}>
                {campaignLoading ? (
                  <div>
                    <CustomSkeleton
                      parentcss={'flex'}
                      countline={1}
                      height={'1.5rem'}
                      width={'2rem'}
                      className="border-round "
                    />
                  </div>
                ) : (
                  <div className="font-semibold">{campaignDetail.totalschedule}</div>
                )}
                <div>Scheduled</div>
              </div>
              <div className={`flex-1 p-1`}>
                {campaignLoading ? (
                  <div>
                    <CustomSkeleton
                      parentcss={'flex'}
                      countline={1}
                      height={'1.5rem'}
                      width={'2rem'}
                      className="border-round "
                    />
                  </div>
                ) : (
                  <div className="font-semibold">{campaignDetail.success}</div>
                )}
                <div>Successful</div>
              </div>
              <div className={`flex-1 p-1`}>
                {campaignLoading ? (
                  <div>
                    <CustomSkeleton
                      parentcss={'flex'}
                      countline={1}
                      height={'1.5rem'}
                      width={'2rem'}
                      className="border-round "
                    />
                  </div>
                ) : (
                  <div className="font-semibold">{campaignDetail.onhold}</div>
                )}
                <div>Hold</div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-6 flex flex-column  bg-white">
          <div className="p-2 flex flex flex-row align-items-center gap-2 ">
            <div className="m-2">
              <DashboardConversations />
            </div>
            <div className=" font-bold flex flex-row gap-2">
              <div className="font-normal">Total Conversation Count</div>
              {campaignLoading ? (
                <div>
                  <CustomSkeleton
                    parentcss={'flex'}
                    countline={1}
                    height={'1.5rem'}
                    width={'2rem'}
                    className="border-round"
                  />
                </div>
              ) : (
                <div className="">{coversationDetail.usedConversation}</div>
              )}
            </div>
          </div>
          <div>
            <div className="flex flex-row pl-8 pr-2 pb-2">
          
              <div className={`w-full p-1`}>
                {campaignLoading ? (
                  <div>
                    <CustomSkeleton
                      parentcss={'flex'}
                      countline={1}
                      height={'1.5rem'}
                      width={'2rem'}
                      className="border-round "
                    />
                  </div>
                ) : (
                  <div className="font-semibold">{`${coversationDetail.successRate} %`}</div>
                )}
                <div>Campaigns Success</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-md font-semibold pb-1 mt-2 p-2">Campaigns</div>
      <div
        className={`w-full  flex flex-column justify-content-between align-items-start  w-12 `}
        style={{ maxHeight: '754px', height: '700px' }}
      >
        <div className={`my-3 mt-2 ${styles['record-wrap-stat']} flex  w-full`}>
          <div className="w-full">
            {campaignLoading ? (
              <div className="flex flex-column gap-4">
                <CustomSkeleton
                  parentcss={'flex flex-row gap-4'}
                  countline={6}
                  height={'1rem'}
                  className="border-round w-2"
                />
                <CustomSkeleton
                  parentcss={'flex flex-row gap-4'}
                  countline={6}
                  height={'1rem'}
                  className="border-round w-2"
                />
                <CustomSkeleton
                  parentcss={'flex flex-row gap-4'}
                  countline={6}
                  height={'1rem'}
                  className="border-round w-2"
                />
                <CustomSkeleton
                  parentcss={'flex flex-row gap-4'}
                  countline={6}
                  height={'1rem'}
                  className="border-round w-2"
                />
              </div>
            ) : (
              <DataTable
                className="skalebot-table"
                value={campaignDataWithSR}
                responsiveLayout="scroll"
                resizableColumns
                columnResizeMode="expand"
                emptyMessage="No data found."
                selection={clickedCampaign}
                stripedRows
                selectionMode="single"
                onSelectionChange={(e) => handleCampaignSelect(e.value)}
              >
                <Column
                  field="campaignName"
                  header="Campaign Name"
                  bodyStyle={{
                    minWidth: '150px',
                    maxWidth: '200px',
                    textTransform: 'capitalize',
                  }}
                  style={{
                    minWidth: '150px',
                    maxWidth: '200px',
                  }}
                  body={(rowData) => <EllipsisText text={rowData.campaignName} />}
                />
                <Column
                  field="conversationsCount"
                  className="text-sm font-normal"
                  style={{ width: '15ch' }}
                  header={'Conversations'}
                  body={(rowData) => rowData?.analytics?.total ?? rowData?.conversationsCount ?? 0}
                />
                <Column
                  field="createdAt"
                  header="Date & Time"
                  style={{ width: '20ch' }}
                  className="text-sm font-normal"
                  body={(rowData) => {
                    let date = getDate(rowData.createdAt)?.split(',');
                    return (
                      <div className="flex flex-column gap-2">
                        <div>{date[0]}</div>
                        <div>{date[1]}</div>
                      </div>
                    );
                  }}
                  bodyStyle={{ textTransform: 'uppercase' }}
                  headerStyle={{ whiteSpace: 'nowrap' }}
                />
                <Column
                  field="message"
                  header={'Message'}
                  bodyStyle={{ minWidth: '250px', maxWidth: '350px' }}
                  body={(rowData) => {
                    let message = refineMessage(rowData?.variables, rowData?.message);
                    return <EllipsisText text={message} />;
                  }}
                />

                <Column
                  header="Campaign Resource"
                  body={mediaBody}
                  style={{ width: '30ch' }}
                  headerStyle={{ whiteSpace: 'nowrap' }}
                ></Column>
                <Column
                  header={() => <div className="pl-4">Status</div>}
                  // field="successRate"
                  style={{ width: '25ch' }}
                  body={successRateBodyTemplate}
                ></Column>
              </DataTable>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CampaignsSectionsWCA;
